import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UsersService } from './users.service';
import { GenericService, LoaderConfig } from './generic.service';
import { ServerResponse } from '../models/ServerResponse';
import { filter, Observable, Subject } from 'rxjs';
import { AssociationTicketData, CreateTicket, CreateTicketFileMessage, CreateTicketMessage, ITicketMessage, Ticket, TicketMessage, TicketTyping } from '../models/Ticket';
import { ISAPI, ISPagination, MVListingConfigs } from 'is-lib';
import { SignalRService } from './signalR.service';
import { Alert, AlertWithTimediff } from '../models/Alert';
import { AlertsService } from './alerts.service';

@Injectable({
    providedIn: 'root'
})
export class TicketsService {
    
    public newMessagesSubject$ = new Subject<TicketMessage>();

    constructor(private genericService: GenericService, private _user: UsersService, private _signalRService: SignalRService, private _alertService: AlertsService) {}

    //#region GET
    getTickets(filters?: MVListingConfigs, callLoader: boolean | LoaderConfig = false): Observable<ServerResponse<Ticket[]>> {
        if (filters == null) {
            filters = new MVListingConfigs([], null, new ISPagination(10, 0))
        }
        return this.genericService.post(`${environment.apiUrl}ClientPortalUsers/${this._user.userCountryCode}/Mine/Tickets/Get`, filters, undefined, callLoader);
    }

    getTicketMessages(ticketId: number, callLoader: boolean | LoaderConfig = true): Observable<ServerResponse<ITicketMessage[]>> {
        return this.genericService.get(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/${ticketId}/Messages`, callLoader);
    }

    getTicketTypes(): Observable<ServerResponse<TicketTyping[]>> {
        return this.genericService.get(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/Types`, true);
    }

    getTicketTypeSubtypes(ticketTypeId: number): Observable<ServerResponse<TicketTyping[]>> {
        return this.genericService.get(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/Types/${ticketTypeId}/Subtypes`, true);
    }
    //#endregion

    //#region POST
    postTicket(body: CreateTicket): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Tickets/${this._user.userCountryCode}`, body, undefined, true)
    }

    postTicketMessage(ticketId: number, body: CreateTicketMessage): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/${ticketId}/Message`, body)
    }

    postTicketMessageFile(ticketId: number, messageId: number, body: FormData): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/${ticketId}/Message/${messageId}/File`, body)
    }
    //#endregion

    //#region PATCH
    associateTicketToEntity(entityId: string, ticketId: string) {
        return this.genericService.patch(`${environment.apiUrl}Entities/${this._user.userCountryCode}/${entityId}/Ticket/${ticketId}/Associate`, undefined, undefined, true)
    }

    associateTicketToElectricitySupplyContract(electricitySupplyContractId: string, ticketId: string) {
        return this.genericService.patch(`${environment.apiUrl}ElectricitySupplyContracts/${this._user.userCountryCode}/${electricitySupplyContractId}/Ticket/${ticketId}/Associate`, undefined, undefined, true)
    }

    associateTicketToNaturalGasSupplyContract(naturalGasSupplyContractId: string, ticketId: string) {
        return this.genericService.patch(`${environment.apiUrl}NaturalGasSupplyContracts/${this._user.userCountryCode}/${naturalGasSupplyContractId}/Ticket/${ticketId}/Associate`, undefined, undefined, true)
    }

    associateTicketToContract(contractId: string, ticketId: string) {
        return this.genericService.patch(`${environment.apiUrl}Contracts/${this._user.userCountryCode}/${contractId}/Ticket/${ticketId}/Associate`, undefined, undefined, true)
    }
    //#endregion
}